// extracted by mini-css-extract-plugin
module.exports = {"vinw7c5":"vinw7c5","section-aside-container":"section-aside-container","c6vqgdx":"c6vqgdx"};